import { useAuthStore } from '@/auth/useAuthStore';

export interface IUseIsDev {
  isDevEnv: boolean;
  isDemoMode: boolean;
  shouldAnonymize: boolean;
}

export const useDevFlag = (): IUseIsDev => {
  const url = window.location.href;
  const isDevEnv = url.includes("localhost") || url.includes("app-dev.");
  const meInfo = useAuthStore((s) => s.meInfo);

  return {
    isDevEnv,
    shouldAnonymize: meInfo?.email === "onboarding@demo.com",
    isDemoMode:
      isDevEnv &&
      (meInfo?.email === "onboarding@demo.com" ||
        meInfo?.email === "mawarid@demo.com"),
  };
};
